module.exports = __webpack_public_path__ + "img/pdf-file-format.a1594f93.png";